/* unplugin-vue-components disabled */import script from "./PanelWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelWrapper.vue?vue&type=script&setup=true&lang=js"

import "./PanelWrapper.vue?vue&type=style&index=0&id=9b230ce8&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b230ce8"]])

export default __exports__